import React from 'react';
import { AlertCircle } from 'lucide-react';
import './Caducado.scss';

function Caducado() {
    return (
        <div className='Caducado'>
            <div className="caducado-card">
                <div className='icon-container'>
                    <AlertCircle size={64} className="warning-icon" />
                </div>
                <h2 className="titulo">Enlace Expirado</h2>
                <p className='mensaje'>
                    Este enlace ha caducado por motivos de seguridad o tiempo de vida. Por favor, póngase en contacto con su clínica o proveedor médico para solicitar un nuevo acceso a su estudio.
                </p>
                {/* <div className="actions">
                    <button className="btn-return" onClick={() => window.location.href = '/'}>
                        Volver al Inicio
                    </button>
                </div> */}
            </div>
        </div>
    );
}

export default Caducado;
